/**
 * Responsibility: Implement quest visibility behavior for the ui/helpers surface.
 * Scope: Owns ui/helpers concerns only; cross-surface orchestration is excluded.
 */
import type { Quest } from "@anyquest/shared-core"

export function computePotentialQuestBudget(historyCount: number): number {
  const turns = Math.max(0, Math.floor(Number(historyCount) || 0))
  return Math.max(1, Math.min(8, 1 + Math.floor(Math.max(0, turns - 1) / 3)))
}

export function applyQuestVisibility(quests: Quest[], historyCount: number): {
  visible: Quest[]
  hiddenPotentialCount: number
  potentialBudget: number
} {
  const budget = computePotentialQuestBudget(historyCount)
  let shownPotential = 0
  let hiddenPotentialCount = 0
  const visible: Quest[] = []

  for (const quest of quests ?? []) {
    if (quest?.status !== 'potential') {
      visible.push(quest)
      continue
    }

    if (shownPotential < budget) {
      visible.push(quest)
      shownPotential += 1
    } else {
      hiddenPotentialCount += 1
    }
  }

  return { visible, hiddenPotentialCount, potentialBudget: budget }
}
